import * as React from 'react';
export const IcInsurance = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.02 6.29c-.28-.33-.66-.53-1.07-.57-1.83-.19-3.61-.72-5.26-1.55-.21-.11-.45-.16-.68-.16-.23 0-.47.05-.68.16C9.69 5 7.92 5.53 6.1 5.72c-.41.04-.81.23-1.09.54-.29.31-.46.72-.47 1.16v4.25c0 5.72 5.6 9.34 7.46 9.34 1.86 0 7.46-3.61 7.46-9.34V7.42c0-.41-.17-.82-.45-1.12h.01v-.01z'
      fill='currentColor'
    />
  </svg>
);
